import { render, staticRenderFns } from "./EnergyChartBox.vue?vue&type=template&id=4ff49d8e&scoped=true"
import script from "./EnergyChartBox.vue?vue&type=script&lang=js"
export * from "./EnergyChartBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff49d8e",
  null
  
)

export default component.exports